module.exports = __webpack_public_path__ + "static/media/users_white.3ba6a4c3.svg";